import { Get, Post } from '../request'

export const fetchMerchandiseLists = (config = null) => {
  return Get('/merchandise', config)
}

export const fetchMerchandiseDetail = ({ id, priceTypeId }) => {
  const config = (priceTypeId != 0) ? { params: { price_type_id: priceTypeId } } : null
  return Get(`/merchandise/${id}`, config)
}

export const fetchMaintenanceMerchandise = ({ id, accessToken }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    }
  }
  return Get(`/mainte/merchandise/${id}`, config)
}

export const updateMaintenanceMerchandise = ({ id, payload, accessToken }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    }
  }
  return Post(`/mainte/merchandise/${id}`, payload, config)
}

export const fetchPriceTypes = ({ accessToken }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    }
  }
  return Get('pricetypes', config)
}
